import { lazy } from "react";
import Loadable from "app/components/Loadable";

const WhatsAppCampaignListPage = Loadable(
  lazy(() => import("./WhatsAppCampaignListPage"))
);
const WhatsAppCampaignReportsPage = Loadable(
  lazy(() => import("./WhatsAppCampaignReportsPage"))
);
const WhatsAppCampaignEditorPage = Loadable(
  lazy(() => import("./WhatsAppCampaignEditorPage"))
);
const WhatsAppCampaignDetailPage = Loadable(
  lazy(() => import("./WhatsAppCampaignDetailPage"))
);
const WhatsAppMarketingTemplateListPage = Loadable(
  lazy(() => import("./WhatsAppMarketingTemplateListPage"))
);
const WhatsAppMarketingTemplateCreatePage = Loadable(
  lazy(() => import("./WhatsAppMarketingTemplateCreatePage"))
);

const WhatsAppCampaignRoutes = [
  {
    path: "/admin/whatsapp-campaigns",
    element: <WhatsAppCampaignListPage />,
  },
  {
    path: "/admin/whatsapp-campaigns/reports",
    element: <WhatsAppCampaignReportsPage />,
  },
  {
    path: "/admin/whatsapp-campaigns/marketing-templates",
    element: <WhatsAppMarketingTemplateListPage />,
  },
  {
    path: "/admin/whatsapp-campaigns/marketing-templates/new",
    element: <WhatsAppMarketingTemplateCreatePage />,
  },
  {
    path: "/admin/whatsapp-campaigns/new",
    element: <WhatsAppCampaignEditorPage />,
  },
  {
    path: "/admin/whatsapp-campaigns/:campaignId/edit",
    element: <WhatsAppCampaignEditorPage />,
  },
  {
    path: "/admin/whatsapp-campaigns/:campaignId",
    element: <WhatsAppCampaignDetailPage />,
  },
];

export default WhatsAppCampaignRoutes;
